import { useEffect, useState } from 'react'

import styled from 'styled-components'

import { useGame } from '../context'
import Board from './Board'
import WordInfo from './WordInfo'

const StyledGameArea = styled.div`
  width: 100%;
  max-width: 60vh;
  flex-grow: 1;
  padding: 0;
  display: flex;
  flex-direction: column;
`

const BoardArea = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
`

const GameArea = () => {
  const [maxLevel, setMaxLevel] = useState(false)
  const [foundAll, setFoundAll] = useState(false)

  const { score, levels, allWords, foundWords, onComplete } = useGame()
  useEffect(() => {
    if (foundWords.length === allWords.length) {
      if (!foundAll) {
        setFoundAll(true)
        setTimeout(onComplete, 500)
      }
    }
  }, [score, levels, allWords, foundWords, foundAll, maxLevel])

  return (
    <StyledGameArea>
      <BoardArea>
        <WordInfo />
        <Board />
      </BoardArea>
    </StyledGameArea>
  )
}

export default GameArea
